export default __webpack_public_path__ + "static/media/step3.7366ac20.jpeg";